import Util from "packs/utils/Util"
import { funcName, Logger } from "packs/common"

export default class FormUtil {
    static getParams(): any {
        let params = {}
        let _params = window.location.search.substr(1).split("&")
        for (let _param of _params) {
            if (!_param) continue

            let [key, value] = _param.split("=").map(decodeURIComponent)

            // ネストしたパラメータの処理（例: attendees[0][name]）
            if (key.includes("[") && key.includes("]")) {
                const matches = key.match(/([^\[]+)(\[.+)/)
                if (matches) {
                    const mainKey = matches[1]
                    const remainingKeys = matches[2]

                    // ネストしたキーを解析
                    const keyParts = [mainKey]
                    const nestedMatches = remainingKeys.match(/\[([^\]]*)\]/g)
                    if (nestedMatches) {
                        nestedMatches.forEach(match => {
                            keyParts.push(match.slice(1, -1))
                        })
                    }

                    // ネストした構造を作成
                    let current = params
                    for (let i = 0; i < keyParts.length; i++) {
                        const part = keyParts[i]

                        if (i === keyParts.length - 1) {
                            // 最後のキーに値を設定
                            current[part] = value
                        } else {
                            // 中間のオブジェクトを作成
                            if (!current[part]) {
                                // 次のキーが数字なら配列、そうでなければオブジェクト
                                const nextIsArray = !isNaN(Number(keyParts[i + 1]))
                                current[part] = nextIsArray ? [] : {}
                            }
                            current = current[part]
                        }
                    }
                }
            } else {
                // 通常のパラメータ
                params[key] = value
            }
        }
        // this.additionalParams = params
        Logger(`パラメータを取得しました: string:${_params} ${Util.output(params)}`)
        return params
    }

    static validateTel(tel): boolean {
        if (Util.isBlank(tel)) return false

        Logger(`${funcName()} tel:${tel}`)
        let telStr = tel.toString()

        telStr = telStr.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248)
        })
        let isValid = false

        if (telStr.length > 5 && telStr.match(/^(?:\+?\d+-)?\d+(?:-\d+){2}$|^\+?\d+$/)) {
            isValid = true
        }
        return isValid
    }

    /**
     * 6文字の乱数を自動で生成します.
     * @param len
     * @returns
     */
    static generateRamdom(len = 6) {
        return Array(len)
            .fill(null)
            .map(() => Math.random().toString(36)[2])
            .join("")
            .toUpperCase()
    }
}
